import { LEAD_ID_FIELD, TRUSTED_FORM_FIELD } from './constants';

/**
 * Makes sure the PII form submits the tokens the provider captured.
 *
 * With early loading, both vendor scripts run plates before the PII `<form>`
 * exists, so neither is guaranteed to fill that form's hidden inputs. For every
 * `universal_leadid` input in the document this:
 * - fills it with the Jornaya token when it is still empty, and
 * - ensures its form carries a populated `xxTrustedFormCertUrl` input, filling
 *   an empty one or appending a hidden one.
 *
 * Values the vendors wrote themselves are never overwritten.
 */
export function syncConsentInputs(
  root: Document,
  { leadId, certUrl }: { leadId?: string; certUrl?: string },
): void {
  root
    .querySelectorAll<HTMLInputElement>(`input[name="${LEAD_ID_FIELD}"]`)
    .forEach((leadIdInput) => {
      if (leadId && !leadIdInput.value) {
        // eslint-disable-next-line no-param-reassign
        leadIdInput.value = leadId;
      }

      const { form } = leadIdInput;
      if (!form || !certUrl) return;

      const certInputs = Array.from(
        form.querySelectorAll<HTMLInputElement>(
          `input[name="${TRUSTED_FORM_FIELD}"]`,
        ),
      );
      if (certInputs.some((input) => input.value)) return;

      if (certInputs[0]) {
        certInputs[0].value = certUrl;
        return;
      }

      const input = root.createElement('input');
      input.type = 'hidden';
      input.name = TRUSTED_FORM_FIELD;
      input.value = certUrl;
      form.appendChild(input);
    });
}
